// extracted by mini-css-extract-plugin
export default {"chart":"DonutNewT_chart__7LTyO","count":"DonutNewT_count__iTbQB","box":"DonutNewT_box__acYlj"};